const regular={
    phone:/^1[23456789]\d{9}$/,
    userCard:/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
    account:/^[a-zA-Z0-9\u4e00-\u9fa5_@#]{1,8}$/,
    password:/^[a-zA-Z0-9_@#]{6,12}$/,
    appPassword:/^[a-zA-Z0-9]{6,12}$/
}
export default regular;